import React, { createContext } from 'react';
import type { LinkResolverType, UrlResolverType } from './Prismic';

export interface IPrismicContext {
  linkResolver: LinkResolverType;
  urlResolver: UrlResolverType;
}

export const PrismicContext = createContext<IPrismicContext>({
  linkResolver: () => 'Missing linkresolver',
  urlResolver: () => ({ href: 'snild' }),
});

interface IPrismicContextProviderProps {
  linkResolver: LinkResolverType;
  urlResolver: UrlResolverType;
}

export const PrismicContextProvider: React.FC<IPrismicContextProviderProps> = ({
  children,
  linkResolver,
  urlResolver,
}) => {
  return (
    <PrismicContext.Provider value={{ linkResolver, urlResolver }}>
      {children}
    </PrismicContext.Provider>
  );
};
